import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import { CohortTotals, CohortProgressTable } from "@/components/CohortProgress";

export default function CohortProgressPage() {
  const { token } = useParams();
  useSeo({ title: "Cohort progress", noindex: true });
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/cohort-progress/${token}`).then((r) => setData(r.data)).catch((e) => setErr(formatApiError(e.response?.data?.detail) || "Link not available"));
  }, [token]);

  if (err) return <div className="min-h-[50vh] grid place-items-center px-4 text-sm text-zinc-600" data-testid="cohort-progress-error">{err}</div>;
  if (!data) return <div className="min-h-[50vh] grid place-items-center text-sm text-zinc-500">Loading…</div>;
  const { cohort, totals, rows, generated_at } = data;
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 space-y-6" data-testid="cohort-progress-page">
      <div>
        <div className="eyebrow mb-2">Converged Security Institute · Cohort progress</div>
        <h1 className="font-display text-3xl sm:text-4xl">{cohort.company}</h1>
        <p className="text-sm text-zinc-600 mt-2">{cohort.name} · {cohort.course_title}</p>
      </div>
      <CohortTotals t={totals}/>
      <CohortProgressTable rows={rows}/>
      <p className="text-xs text-zinc-500">Read-only report shared by the CSI Admin team. Updated live · {new Date(generated_at).toLocaleString()}. Pass mark 70%. Certificates are issued by the CSI Administrator by separate email.</p>
    </div>
  );
}
